<template>
  <div class="duration-time-filter__items">
    <button
      v-for="time of durationTimeList"
      :key="time.value"
      :class="['duration-time-filter__item', { 'duration-time-filter__item-active': isChosenTime(time.value) }]"
      @click="timeClickHandler(time.value)"
    >
      {{ time.text }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import { useComponentI18n } from '@/shared/composables/useComponentI18n.ts';
  import { locales } from '@/features/filter/duration-interval';

  interface Props {
    durationInterval: string[];
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{ (e: 'update:modelValue', value: string[]): void }>();

  const { t } = useComponentI18n(locales);

  const durationTimeList = [
    { text: t('durationInterval.uptoTwoHours'), value: 'upto_2_hours' },
    { text: t('durationInterval.fromTwoToFourHours'), value: 'from_2_to_4_hours' },
    { text: t('durationInterval.fromFourToSixHours'), value: 'from_4_to_6_hours' },
    { text: t('durationInterval.fromSixHours'), value: 'from_6_hours' },
  ];

  const isChosenTime = (timeValue: string) => {
    return props.durationInterval.includes(timeValue);
  };
  const timeClickHandler = (timeValue: string) => {
    let value = [...props.durationInterval];

    if (isChosenTime(timeValue)) {
      value = value.filter((item) => item !== timeValue);
    } else {
      value.push(timeValue);
    }
    emit('update:modelValue', value);
  };
</script>

<style scoped lang="scss">
  .duration-time-filter__items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    margin-top: 8px;
  }

  .duration-time-filter__item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--alias-space-4) var(--alias-space-12);
    border: none;
    border-radius: 8px;
    background: var(--comp-chips-color-background);
    color: var(--comp-chips-color-label);
    font-size: 17px;
    line-height: 24px;
    text-decoration: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: var(--comp-chips-color-background-hovered);
    }
  }

  .duration-time-filter__item-active {
    background: var(--comp-chips-color-background-selected);
    color: var(--comp-chips-color-label-selected);

    &:hover {
      background: var(--comp-chips-color-background-selected);
    }
  }
</style>
